import validator from 'validator';
import isEmpty from '../utils/isEmpty';
import isEmptyValidator from './isEmptyValidator';

export default function validateRegisterInput(data) {
  let errors = {};
  errors = isEmptyValidator(errors, data.name, 'name');
  errors = isEmptyValidator(errors, data.email, 'email');

  if (!errors.name && !validator.isLength(data.name, { min: 2, max: 30 })) {
    errors.name = 'Name must be between 2 and 30 characters';
  }

  if (!errors.email && !validator.isEmail(data.email)) {
    errors.email = 'Email is invalid';
  }

  const message = !isEmpty(data.message) ? data.message : '';
  if (validator.isEmpty(message)) {
    errors.message = 'To better help you, please share with me your thoughts!';
  }

  return { errors, isValid: isEmpty(errors) };
}
